export function normalizeReservation(r) {
  const pricing = r.customer_pricing || {};
  const totals = pricing.totals || {};
  const itinerary = r.itinerary || {};
  const pickup = itinerary.pickup || {};
  const dropOff = itinerary.drop_off || {};

  // Calculate pricing values needed by the UI
  const rentalTotal = (totals.total_amount || 0)
  const payNow = (totals.prepaid_amount || 0)
  const payAtRentalDesk = (totals.pay_at_pickup || 0)
  const extras = pricing.extras_amount || 0;
  
  return {
    reservationNo: r.reservation_no, 
    vendorReservationNo: r.vendor_reservation_no, 
    status: r.booking_status,
    rentalDays: r.rental_days,

    vendor: {
      code: r.vendor?.code,
      name: r.vendor?.name, 
      logo: r.vendor?.logo,
    },

    car: {
      makeAndModel: r.car?.make_and_model, 
      sippCode: r.car?.sipp_code, 
      transmission: r.car?.transmission, 
      airConditioning: r.car?.air_conditioning, 
      doors: r.car?.doors,
      seats: r.car?.seats, 
      carImage: r.car?.car_image,
      isExactModel: r.car?.is_exact_model,
      fuelPolicy: r.car?.fuel_policy,
    },

    itinerary: {
      pickupLocationName: pickup.location_name,
      pickupDateTime: pickup.date_time,
      pickupLocationCode: pickup.location_code,
      pickupAddress: pickup.location_address,  
      pickupContact: pickup.location_contact,  
      pickupHours: pickup.business_hours, 
      
      dropOffLocationName: dropOff.location_name,
      dropOffDateTime: dropOff.date_time,
      dropOffLocationCode: dropOff.location_code,
      dropOffAddress: dropOff.location_address,
      dropOffContact: dropOff.location_contact,
      dropOffHours: dropOff.business_hours,
    },

    customer: {
      firstName: r.customer?.first_name, 
      lastName: r.customer?.last_name, 
      email: r.customer?.email, 
      phone: r.customer?.phone, 
      dob: r.customer?.dob,
      address: r.customer?.address,
      flightNumber: r.customer?.flight_number, 
      residency: r.customer?.residency,
    },

    pricing: {
      currency: pricing.currency || "INR", 
      totalRentalPrice: rentalTotal,
      payNow: payNow,
      payAtDesk: Math.max(payAtRentalDesk),
      extrasAmount: extras,
      extrasList: pricing.extras || [],
    },

    policy: {
      depositAmount: r.deposit_amount, 
      excessAmount: r.excess_amount,
      inclusions: r.inclusions_info || [], 
      cancellationNotes: r.cancellation_policy?.notes || [], 
    }
  };
}